import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'flat';
}
export function Card({
  className = '',
  variant = 'default',
  children,
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-white shadow-lg shadow-[#8B7355]/5 border border-[#FAF7F2]',
    flat: 'bg-[#FAF7F2] border border-[#E5E0D8]'
  };
  return <div className={`rounded-xl overflow-hidden ${variants[variant]} ${className}`} {...props} data-id="element-210">
      {children}
    </div>;
}